import MigratingEvents from "../../../../contents/docs/migrate/snippets/migrating-events.mdx";
import * as React from 'react';
export default {
  MigratingEvents,
  React
};